<!--  -->
<template>
  <div class="">
    <div class="btns flex-items">
      <el-select
        v-model="TypeId"
        placeholder="请选择"
        style="margin-right: 10px"
        @change="onChangeType"
      >
        <el-option
          v-for="item in classList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button type="primary" @click="addTeacher">新增维度</el-button>
      <el-button
        type="danger"
        @click="WebDeleteMyQuestionCategory"
        :disabled="this.selsectId.length == 0"
        >删除</el-button
      >
      <!-- <el-button type="primary" @click="DownFile">下载模板</el-button> -->
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
        }"
        @selection-change="handleSelectionChange"
        empty-text="暂无数据"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column type="index" width="55"> </el-table-column>
        <el-table-column prop="Name" label="维度名称" align="center">
        </el-table-column>
        <el-table-column prop="For" label="周期" align="center">
        </el-table-column>
        <el-table-column prop="StatusName" label="状态" align="center">
        </el-table-column>
        <el-table-column label="预览" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              @click="handleEdit(scope.$index, scope.row)"
              >预览</el-button
            >
          </template>
        </el-table-column>

        <el-table-column label="导入试题" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" style="position: relative"
              ><input
                class="upload_file"
                id="file"
                @input="uploadFile($event, scope.row)"
                type="file"
              />导入试题</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="开启/关闭" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.Status == 1"
              type="danger"
              size="mini"
              @click="IsOpenQuestionType(scope.$index, scope.row)"
              >点击关闭</el-button
            >
            <el-button
              v-else
              type="warning"
              size="mini"
              @click="IsOpenQuestionType(scope.$index, scope.row)"
              >点击开启</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="DownFile(scope.row)"
              >下载模板</el-button
            >
            <!-- <el-button
              size="mini"
              type="success"
              @click="onClickEditQuestion(scope.row)"
              >编辑试题</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog width="30%" :visible.sync="AddMask" title="新增自定义维度">
      <el-form
        ref="form"
        :model="addForm"
        class="form"
        :rules="rules"
        label-position="top"
      >
        <el-form-item label="名称" style="margin-top: 20px" prop="name">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item
          label="托班/小中大"
          style="margin-top: 20px"
          prop="TypeId"
        >
          <el-select
            v-model="addForm.TypeId"
            placeholder="请选择"
            style="margin-right: 10px"
            @change="onChangeTypeAdd"
          >
            <el-option
              v-for="item in classList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="addForm.TypeId == 4"
          label="周期"
          style="margin-top: 20px"
          prop="TypeId"
        >
          <el-select
            v-model="addForm.CycleId"
            placeholder="请选择"
            style="margin-right: 10px"
          >
            <el-option
              v-for="item in LeveData"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="介绍" style="margin-top: 20px" prop="Detail">
          <el-input v-model="addForm.Detail"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="PreserveAdd">提交</el-button>
        <el-button @click="closeAdd">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="题目预览" :visible.sync="previewVisible" width="30%">
      <div v-for="(item, index) in previewInfo" :key="index">
        <div class="Ex_Questions">{{ index + 1 }}. {{ item.Ex_Questions }}</div>
        <div>
          <div
            class="Ex_AnswerList"
            v-for="(Ex_AnItem, Ex_AnIndex) in item.Ex_AnswerList"
            :key="Ex_AnIndex"
          >
            {{ Ex_AnItem.Question }}
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="题目预览" :visible.sync="previewVisibleTwo" width="30%">
      <div v-for="(item, index) in previewInfoList" :key="index">
        <div class="Ex_Questions">{{ index + 1 }}. {{ item.Ex_Questions }}</div>
        <div>
          <div
            class="Ex_AnswerList"
            v-for="(Ex_AnItem, Ex_AnIndex) in item.Ex_AnswerList"
            :key="Ex_AnIndex"
          >
            {{ Ex_AnItem.Option }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  GetMyQuestionCategoryList,
  AddMyQuestionCategoryInfo,
  WebDeleteMyQuestionCategory,
  FileUploadsExcel,
  ImportMyQuestionCategoryInfo,
  SetTeacherRole,
  IsOpenQuestionType,
  GetMyQuestionList,
  GetBabyLevelInfo,
  ImportMyQuestionCategoryByZeroInfo,
  GetMyQuestionListByZero,
} from "../../api/api";
export default {
  //import引入的组件需要注入到对象中才能使用
  data() {
    //这里存放数据
    return {
      Id: 0,
      RoleId: "",
      RoleIndex: 0,
      roleType: 1,
      dialogVisibleRole: false,
      EditMask: false, //设置弹窗show
      data: [], //树的数据
      checked: [], //默认选中项
      optionsStudy: [],
      studyName: "",
      StudyId: "",
      checkedInfos: [], //选中的信息
      defaultProps: {
        children: "Children",
        label: "Label",
        Id: "Id",
      },
      dialogVisible: false, //文件上传弹窗
      previewVisible: false,
      previewInfo: [],
      previewVisibleTwo: false,
      previewInfoList: [],
      teacherId: "", //设置的教师Id
      excelurl: "", //上传文件返回url
      title: "权限管理", //内容标题
      showMask: false, //编辑弹窗
      AddMask: false, //添加弹窗
      PwdMask: false, //密码弹窗
      tableData: [], //教师列表
      addForm: {
        name: "",
        sex: "0",
        phone: "",
        Detail: "",
        TypeId: "",
        CycleId: "",
      }, //添加信息对象
      rules: {
        name: [{ required: true, message: "请输名称", trigger: "blur" }],
        Detail: [{ required: true, message: "请输入介绍", trigger: "blur" }],
        TypeId: [
          { required: true, message: "请选择托班/小中大", trigger: "change" },
        ],
        CycleId: [{ required: true, message: "请选择周期", trigger: "change" }],
      }, //输入框判定
      editForm: {
        id: "",
        name: "",
        sex: "",
        phone: "",
      }, //修改信息对象
      pwdForm: {
        password: "",
      }, //重置密码
      selsectId: [], //多选选中的Id
      page: 1, //初始页码
      LastPage: "", //总页数
      roles: ["教师", "年级组长", "教师、年级组长"],
      loading: undefined,
      classList: [
        {
          label: "托班",
          value: 4,
        },
        {
          label: "小中大",
          value: 2,
        },
      ],
      TypeId: 2,
      LeveData: [],
      importType: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 编辑试题
    onClickEditQuestion() {},
    onChangeType(e) {
      console.log(e);
      this.TypeId = e;
      this.GetMyQuestionCategoryList();
    },
    async onChangeTypeAdd(e) {
      this.addForm.TypeId = e;
      if (e == 4) {
        this.GetBabyLevelInfo();
      }
    },
    async GetBabyLevelInfo() {
      let res = await GetBabyLevelInfo();
      if (res.data.success) {
        this.LeveData = res.data.response;
      }
    },
    chooseRole(index) {
      this.RoleIndex = index;
      this.roleType = index + 1;
    },

    DownFile(item) {
      if (item.For == "3-6") {
        location.href =
          "https://mushroomisand.oss-cn-shanghai.aliyuncs.com/downfile/校园特色导入模板.xlsx";
      } else {
        location.href =
          "https://mushroomisand.oss-cn-shanghai.aliyuncs.com/downfile/校园特色0-3导入模板.xlsx";
      }
    },
    //关闭设置弹窗
    closeEditPreserve() {
      this.EditMask = false;
      this.checkedInfos = [];
    },
    beforeUpload(file) {
      //console.log("beforeUpload");
      //console.log(file.type);
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      return isText | isTextComputer;
    },
    // 上传文件个数超过定义的数量
    handleExceed() {
      this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传`);
    },
    ////导入信息 上传选择文件
    uploadFile(item, row) {
      this.importType = row.For;
      //console.log(item, row);
      if (!this.loading) {
        this.loading = this.$loading({
          lock: true,
          text: "数据导入中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
      }
      this.Id = row.Id;
      const fileObj = item.target.files[0];
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      form.append("filetype", "excel");
      FileUploadsExcel(form).then((response) => {
        if (response.data.success) {
          this.excelurl = response.data.response;
          let file = document.getElementById("file");
          file.value = ""; //file的value值只能设置为空字符串
          if (this.importType == "3-6") {
            this.SubmitUploadFile();
          } else {
            this.SubmitUploadFileTwo();
          }
        } else {
          if (this.loading) {
            this.loading.close();
            this.loading = undefined;
          }
          this.$message.error("导入失败");
        }
      });
    },
    // 0-3
    SubmitUploadFileTwo() {
      console.log("0-3");
      if (this.excelurl) {
        ImportMyQuestionCategoryByZeroInfo({
          Id: this.Id,
          Excelurl: this.excelurl,
        }).then((res) => {
          if (this.loading) {
            this.loading.close();
            this.loading = undefined;
          }
          if (res.data.success) {
            this.GetMyQuestionCategoryList();
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.dialogVisible = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      } else {
        this.$message({
          message: "请选择文件",
          type: "error",
        });
      }
    },
    SubmitUploadFile() {
      console.log("3-6");

      if (this.excelurl) {
        ImportMyQuestionCategoryInfo({
          Id: this.Id,
          Excelurl: this.excelurl,
        }).then((res) => {
          if (this.loading) {
            this.loading.close();
            this.loading = undefined;
          }
          if (res.data.success) {
            this.GetMyQuestionCategoryList();
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.dialogVisible = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      } else {
        this.$message({
          message: "请选择文件",
          type: "error",
        });
      }
    },
    //获取信息列表
    GetMyQuestionCategoryList() {
      GetMyQuestionCategoryList({
        TypeId: this.TypeId,
      }).then((res) => {
        if (res.data.success) {
          // //console.log(res.data.response);
          this.tableData = res.data.response;
          this.Id = res.data.Id;
          //console.log(res.data.response);
          //   this.LastPage = res.data.response.pageCount;
          //   this.page = 1;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
          this.tableData = [];
          this.Id = 0;
        }
      });
    },
    //新增教师人员
    addTeacher() {
      this.AddMask = true;
    },
    //多选功能
    handleSelectionChange(val) {
      let list = [];
      val.forEach((item) => {
        //  //console.log(item.Id);
        if (!list.includes(item.Id)) {
          list.push(item.Id);
        }
      });
      this.selsectId = list;
      //console.log(this.selsectId);
    },
    //删除教师按钮
    WebDeleteMyQuestionCategory() {
      WebDeleteMyQuestionCategory({
        Id: this.selsectId[0],
      }).then((res) => {
        if (res.data.success) {
          this.GetMyQuestionCategoryList();
          this.$message({
            message: "删除成功",
            type: "success",
          });
        }
      });
    },

    //关闭重置模板
    IsOpenQuestionType(index, row) {
      IsOpenQuestionType({ Id: row.Id }).then((res) => {
        if (res.data.success) {
          this.GetMyQuestionCategoryList();
          this.$message({
            message: res.data.msg,
          });
        } else {
          this.$message({
            message: res.data.msg,
          });
        }
      });
    },
    handleImport(index, row) {
      //console.log(row);
      this.Id = row.Id;
      this.dialogVisible = true;
    },
    //编辑按钮
    async handleEdit(index, row) {
      if (row.For == "3-6") {
        let xhr = await GetMyQuestionList({
          id: row.Id,
        });
        if (xhr.data.success) {
          this.previewVisible = true;
          this.previewInfo = xhr.data.response;
        } else {
          this.$message.error(xhr.data.msg);
        }
      } else {
        let res = await GetMyQuestionListByZero({
          id: row.Id,
        });
        if (res.data.success) {
          this.previewVisibleTwo = true;
          this.previewInfoList = res.data.response;
        } else {
          this.$message.error(res.data.msg);
        }
      }
      //console.log(xhr.data.response);
    },
    //编辑模板提交成功按钮
    preserveSuccess(success) {
      this.showMask = success;
    },
    //关闭编辑模板按钮
    closePreserve(close) {
      //console.log("关闭");
      this.showMask = close;
    },
    //提交新增信息
    PreserveAdd() {
      if (this.addForm.name && this.addForm.Detail) {
        AddMyQuestionCategoryInfo({
          name: this.addForm.name,
          Detail: this.addForm.Detail,
          typeId: this.addForm.TypeId,
          level: this.addForm.TypeId == 4 ? this.addForm.CycleId : 0,
        })
          .then((res) => {
            if (res.data.success) {
              this.GetMyQuestionCategoryList();
              this.$message({
                message: "增加成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          })
          .catch((err) => {
            this.$message({
              message: "操作失败",
              type: "error",
            });
          });
        // //console.log(this.addForm);
        this.AddMask = false;
        this.addForm = {
          name: "",
          sex: "0",
          phone: "",
          Detail: "",
        };
      } else {
        this.$message({
          message: "请补充添加信息",
        });
      }
    },
    //关闭提交模态框
    closeAdd() {
      this.AddMask = false;
    },
    //上一页
    prevPage() {
      if (this.page > 1) {
        this.page--;
        GetMyQuestionCategoryList({
          PageIndex: this.page,
          PageSize: 10,
        }).then((res) => {
          if (res.status == 200) {
            //console.log(res.data.response.data);
            this.tableData = res.data.response.data;
          }
        });
      } else {
        this.$message({
          message: "当前已是首页",
        });
      }
    },
    //下一页
    nextPage() {
      if (this.page < this.LastPage) {
        this.page++;
        GetMyQuestionCategoryList({
          PageIndex: this.page,
          PageSize: 10,
        }).then((res) => {
          if (res.status == 200) {
            //console.log(res.data.response.data);
            this.tableData = res.data.response.data;
          }
        });
      } else {
        this.$message({
          message: "当前已是尾页",
        });
      }
    },
    //尾页
    toLastPage() {
      this.page = this.LastPage;
      GetMyQuestionCategoryList({
        PageIndex: this.page,
        PageSize: 10,
      }).then((res) => {
        if (res.status == 200) {
          //console.log(res.data.response.data);
          this.tableData = res.data.response.data;
        }
      });
    },
  },
  beforeCreate() {}, //生命周期 - 创建之前
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // getAcademicSelect().then((res) => {
    //   if (res.status == 200) {
    //     // //console.log(res.data.response);
    //     this.optionsStudy = res.data.response;
    //   }
    // });
  },
  mounted() {
    this.GetMyQuestionCategoryList();
  },
};
</script>
<style scoped lang="less">
/deep/.el-dialog {
  border-radius: 10px;
  overflow: hidden;
}
/deep/.el-dialog__header {
  background: #f2f5ff;
}
.upload_file {
  position: absolute;
  width: 100%;
  height: 100%;
  display: block;
  top: 0;
  left: 0;
  opacity: 0;
}
.role {
  width: 120px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  margin-left: 20px;
  cursor: pointer;
  background: #ffffff;
  border: 1px solid #999999;
  border-radius: 5px;
}
.roles {
  background: #409eff;
  color: #ffffff;
  border-color: #409eff;
}

.table {
  margin-top: 20px;
}
.paging {
  margin-left: 20px;
  margin-top: 20px;
}
.last_btn {
  margin-left: 20px !important;
}
.mask {
  width: 500px;
  position: absolute;
  z-index: 100;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(33, 51, 74, 0.2);
  left: 24%;
  top: 0;
}
.mask .mask_title {
  height: 60px;
  line-height: 60px;
  font-weight: 400;
  color: #333333;
  background: #dbf4ff;
  padding-left: 30px;
}
.form {
  padding: 10px 30px;
}
.editmask {
  position: absolute;
  z-index: 100;
  /* margin: 0 auto; */
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(33, 51, 74, 0.2);
  left: 30%;
  top: 0%;
}
.editmask .mask_title {
  height: 60px;
  line-height: 60px;
  font-weight: 400;
  color: #333333;
  background: #dbf4ff;
  padding-left: 30px;
}
.Ex_Questions {
  font-weight: bold;
  margin-top: 10px;
}
.Ex_AnswerList {
  padding-left: 20px;
  margin-top: 5px;
}
</style>